module.exports = __webpack_public_path__ + "img/fast.f7926b74.png";